import { useCallback } from 'react';
import { useAppDispatch } from './useAppStore';
import { addToast } from '../store/slices/adminUiSlice';

export function useToast() {
  const dispatch = useAppDispatch();
  const toast = useCallback(
    (message: string, type: 'success' | 'error' | 'info' = 'info') => dispatch(addToast({ message, type })),
    [dispatch],
  );
  return { toast };
}
